
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $5c22f3002e2c41cf$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["jYV8q","index.ccab856e.js","6S4Ek","../Karappo.c6893bef.mp3"]'));

// Autrona Acoustic Computer Kernel Module: Audio
// Main Web Audio API module, takes care of creating and resuming
// Audio context, maintaining sources and providing some effects.
var $ca39561ab740a9e5$exports = {};

$parcel$export($ca39561ab740a9e5$exports, "load", function () { return $ca39561ab740a9e5$export$11e63f7b0f3d9900; });
$parcel$export($ca39561ab740a9e5$exports, "play", function () { return $ca39561ab740a9e5$export$899fbdb5fa08b653; });
$parcel$export($ca39561ab740a9e5$exports, "audioBuffers", function () { return $ca39561ab740a9e5$export$c2a342ec653dfb48; });
// Audio kernel module: Buffer
// Manages loading, decoding and plaback of audioBuffers

// References
const $ca39561ab740a9e5$export$c2a342ec653dfb48 = {};
function $ca39561ab740a9e5$export$11e63f7b0f3d9900(name, url, progress = null) {
    const request = new XMLHttpRequest();
    const promise = new Promise((resolve, reject)=>{
        request.open("GET", url, true);
        request.responseType = "arraybuffer";
        request.onload = ()=>{
            resolve($ca39561ab740a9e5$var$decode(name, request.response));
        };
        request.onerror = ()=>{
            reject();
            console.error(`An error occured while getting '${name}' audio from '${url}'`);
        };
        request.onprogress = (e)=>{
            const percent = Math.round(e.loaded / e.total * 100);
            if (typeof progress === "function") progress(percent);
            if (DEVMODE) console.log(`Progress loading '${name}' audio file`, percent + "%");
        };
        request.send();
    });
    return promise;
}
function $ca39561ab740a9e5$var$decode(name, arrayBuffer) {
    const promise = new Promise((resolve, reject)=>{
        $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.decodeAudioData(arrayBuffer, (buffer)=>{
            $ca39561ab740a9e5$export$c2a342ec653dfb48[name] = buffer;
            resolve();
            if (DEVMODE) console.log(`Decoded '${name}' audio buffer`);
        }, (e)=>{
            reject();
            console.error("Error while decoding audio data: " + e);
        });
    });
    return promise;
}
function $ca39561ab740a9e5$export$899fbdb5fa08b653(name, options = {}) {
    if ($ca39561ab740a9e5$export$c2a342ec653dfb48[name] === undefined) {
        console.error(`Play error: '${name}' audio buffer does not exist.`);
        return false;
    }
    $fbf4b345a0c4cd2e$export$fbb4d68fe60c1629();
    // Create a new source
    const source = $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.createBufferSource();
    const gainNode = $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.createGain();
    if (options.initialGain != undefined) // Note: this initial gain value will only be applied after that time
    // have passed (it does not change immediately).
    gainNode.gain.setValueAtTime($fbf4b345a0c4cd2e$export$33ed28de027e9482(options.initialGain), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime);
    source.gainNode = gainNode; // custom property for reference
    source.fadeTo = $fbf4b345a0c4cd2e$export$549ee30ac73cf40b; // custom function
    source.fade = $fbf4b345a0c4cd2e$export$cbea29d068a2e18f; // custom function
    source.connect(gainNode);
    gainNode.connect(options.destination || $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.destination);
    // Optional looping parameters
    source.loop = options.loop || false;
    source.loopStart = options.loopStart || 0;
    source.loopEnd = options.loopEnd || 0;
    // Optional starting parameters
    const when = (options.when || 0) + $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime;
    const offset = options.offset || 0;
    const duration = options.duration || undefined;
    // ... more options to come (detune, playBackRate)?
    // Assign an already loaded and decoded buffer
    source.buffer = $ca39561ab740a9e5$export$c2a342ec653dfb48[name];
    // On ended event
    source.onended = ()=>{
        if (typeof options.onended === "function") options.onended();
        $fbf4b345a0c4cd2e$export$93c25f2590a5b540(source);
    };
    // Start producing sound
    if (options.defer === undefined) source.start(when, offset, duration);
    // Maintain references to this source
    $fbf4b345a0c4cd2e$export$d1d41f0cda037248.push(source);
    return source;
}


// References
let $fbf4b345a0c4cd2e$export$a078c61943f9dbbe;
const $fbf4b345a0c4cd2e$export$d1d41f0cda037248 = [];
function $fbf4b345a0c4cd2e$export$2cd8252107eb640b() {
    // Create AudioContext
    if (typeof AudioContext !== "undefined") $fbf4b345a0c4cd2e$export$a078c61943f9dbbe = new AudioContext();
    else // For Safari
    $fbf4b345a0c4cd2e$export$a078c61943f9dbbe = new webkitAudioContext();
    if (DEVMODE) console.log("Audio context sample rate: " + $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.sampleRate);
}
function $fbf4b345a0c4cd2e$export$fbb4d68fe60c1629() {
    // Resume context, dealing with autoplay policy
    if ($fbf4b345a0c4cd2e$export$a078c61943f9dbbe.state === "suspended") {
        if (DEVMODE) console.log("Resuming AudioContext");
        return $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.resume();
    } else return Promise.resolve();
}
// Fade to an absolute level in db
// Default to a fade in behavior from -90db
// this function is used as a source method 
function $fbf4b345a0c4cd2e$export$549ee30ac73cf40b(time = 2, level = 0, fromLevel = -90, mode = "linear") {
    this.gainNode.gain.setValueAtTime($fbf4b345a0c4cd2e$export$33ed28de027e9482(fromLevel), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime($fbf4b345a0c4cd2e$export$33ed28de027e9482(level), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime($fbf4b345a0c4cd2e$export$33ed28de027e9482(level), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
// Fade to a new level by applying a relative db gain
// Defaults to a fade out behavior
// this function is used as a source method 
function $fbf4b345a0c4cd2e$export$cbea29d068a2e18f(time = 2, db = -90, andStop = false, mode = "linear") {
    const currentGain = this.gainNode.gain.value;
    // This setValueAtTime call below is required for Firefox and Safari.
    // Otherwise, linearRampToValueAtTime will do nothing until
    // ac.currentTime + time is reached and then immeditaley drop to -90db.
    // Is this a bug?
    this.gainNode.gain.setValueAtTime(currentGain, $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime);
    if (mode === "linear") this.gainNode.gain.linearRampToValueAtTime(currentGain * $fbf4b345a0c4cd2e$export$33ed28de027e9482(db), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime + time);
    else this.gainNode.gain.exponentialRampToValueAtTime(currentGain * $fbf4b345a0c4cd2e$export$33ed28de027e9482(db), $fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime + time);
    if (andStop) this.stop($fbf4b345a0c4cd2e$export$a078c61943f9dbbe.currentTime + time);
    return this;
}
function $fbf4b345a0c4cd2e$export$51b36263b660c3ee(time = 2, finalGain = -90) {
    // Fade out all sources and stop them
    $fbf4b345a0c4cd2e$export$d1d41f0cda037248.forEach((s)=>s.fade(time, finalGain, true));
}
function $fbf4b345a0c4cd2e$export$33390c3a9a83a2f() {
    $fbf4b345a0c4cd2e$export$d1d41f0cda037248.forEach((s)=>s.stop());
}
function $fbf4b345a0c4cd2e$export$93c25f2590a5b540(source) {
    const index = $fbf4b345a0c4cd2e$export$d1d41f0cda037248.indexOf(source);
    $fbf4b345a0c4cd2e$export$d1d41f0cda037248.splice(index, 1);
}
function $fbf4b345a0c4cd2e$export$e2eaa0ea75f89eaa(gain) {
    return 20 * log10(gain);
    function log10(x) {
        return Math.log(x) / Math.LN10;
    }
}
function $fbf4b345a0c4cd2e$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}




function $6447d0dadb519ccd$export$2cd8252107eb640b() {
    document.querySelector(".js-start").addEventListener("click", ()=>{
        if (DEVMODE) console.log("Starting...");
        document.querySelector(".js-start").classList.add("hidden");
        document.querySelector(".center").classList.add("hidden");
        document.querySelector(".screen").classList.remove("hidden");
        $fbf4b345a0c4cd2e$export$fbb4d68fe60c1629().then(()=>{
            $7d4c530c74e1df86$export$b3571188c770cc5a();
        });
    });
}
function $6447d0dadb519ccd$export$471f7ae5c4103ae1(status) {
    const statusEl = document.querySelector("#status");
    if (status === null) statusEl.classList.add("hidden");
    else statusEl.classList.remove("hidden");
    statusEl.innerText = status;
}
function $6447d0dadb519ccd$export$4bb981a91e4f02eb() {
    document.querySelector(".js-start").classList.remove("hidden");
    $6447d0dadb519ccd$export$471f7ae5c4103ae1(null);
}



var $cef6fcc3e6d79872$exports = {};
$cef6fcc3e6d79872$exports = new URL("../Karappo.c6893bef.mp3", import.meta.url).toString();


const $498b576c6cd78554$var$sounds = [
    {
        name: "karappo",
        url: new URL($cef6fcc3e6d79872$exports)
    }
];
function $498b576c6cd78554$export$2cd8252107eb640b() {
    return $498b576c6cd78554$var$loadSounds();
}
function $498b576c6cd78554$var$loadSounds() {
    return Promise.all([
        ...$498b576c6cd78554$var$sounds.map((sound)=>{
            return $ca39561ab740a9e5$exports.load(sound.name, sound.url);
        })
    ]).then(()=>{
        if (DEVMODE) console.log("All sounds loaded");
    });
}



const $2d3ddcab38f815d7$var$MARK = "\xa7";
let $2d3ddcab38f815d7$var$karaokeText;
const $2d3ddcab38f815d7$var$timeouts = [];
const $2d3ddcab38f815d7$var$karaokeData = [
    {
        "bar": 2,
        "txt": "\xa7[une voix qui s\u2019excuse]"
    },
    {
        "bar": 4,
        "txt": ""
    },
    {
        "bar": 5,
        "txt": "\xa7[une voix narrative]"
    },
    {
        "bar": 6,
        "txt": ""
    },
    {
        "bar": 7,
        "txt": "\xa7[le piano se ferme]"
    },
    {
        "bar": 8,
        "txt": ""
    },
    {
        "bar": 9,
        "txt": "\xa7[les bois, les cuivres se retirent]"
    },
    {
        "bar": 10,
        "txt": ""
    },
    {
        "bar": 11,
        "txt": "\xa7[les percussions s\u2019en vont]"
    },
    {
        "bar": 12,
        "txt": ""
    },
    {
        "bar": 13,
        "txt": "\xa7[les cordes se dispersent]"
    },
    {
        "bar": 14,
        "txt": ""
    },
    {
        "bar": 15,
        "txt": "\xa7[les premiers violons<br>sont d\xe9j\xe0 \xe0 l\u2019h\xf4tel]"
    },
    {
        "bar": 16,
        "txt": ""
    },
    {
        "bar": 17,
        "txt": "\xa7[je suis second]"
    },
    {
        "bar": 18,
        "txt": ""
    },
    {
        "bar": 19,
        "txt": "\xa7[la voix qui s\u2019excuse dispara\xeet]"
    },
    {
        "bar": 20,
        "txt": ""
    },
    {
        "bar": 21,
        "txt": "\xa7[c\u2019est \xe0 vous je crois]"
    },
    {
        "bar": 22,
        "txt": ""
    },
    {
        "bar": 23,
        "txt": "\xa7[\xe0 vous]"
    },
    {
        "bar": 24,
        "txt": ""
    },
    {
        "bar": 25,
        "txt": "Main droite\xa7 la ligne"
    },
    {
        "bar": 26,
        "txt": "D'horizon\xa7 s'affine"
    },
    {
        "bar": 27,
        "txt": "Des villes-\xa7violons"
    },
    {
        "bar": 28,
        "txt": "Dehors\xa7 ils sont"
    },
    {
        "bar": 29,
        "txt": "Pench\xe9s\xa7 \xe0 peine"
    },
    {
        "bar": 30,
        "txt": "Peuvent-ils\xa7 se perdre ?"
    },
    {
        "bar": 31,
        "txt": "La nuit\xa7 les prend"
    },
    {
        "bar": 32,
        "txt": "en ti\xa7tubant"
    },
    {
        "bar": 33,
        "txt": "Main droite\xa7 la ville"
    },
    {
        "bar": 34,
        "txt": "Des an\xa7dro\xefdes"
    },
    {
        "bar": 35,
        "txt": "Sans feu\xa7 sans \xe2me"
    },
    {
        "bar": 36,
        "txt": "Sous o\xa7riflammes"
    },
    {
        "bar": 37,
        "txt": "C'est kitsch\xa7 pourtant"
    },
    {
        "bar": 38,
        "txt": "Les glitchs\xa7 d'\xe9crans"
    },
    {
        "bar": 39,
        "txt": "Restent me\xa7na\xe7ants"
    },
    {
        "bar": 40,
        "txt": "Omni\xa7pr\xe9sents"
    },
    {
        "bar": 42,
        "txt": ""
    },
    {
        "bar": 44,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 45,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 46,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 47,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 48,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 49,
        "txt": "Des symboles"
    },
    {
        "bar": 50,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 51,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 52,
        "txt": "Main gauche\xa7 le fil"
    },
    {
        "bar": 53,
        "txt": "De la rivi\xe8re\xa7 dessine"
    },
    {
        "bar": 54,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 55,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 56,
        "txt": "Main gauche\xa7 le fil"
    },
    {
        "bar": 57,
        "txt": "De la rivi\xe8re\xa7 dessine"
    },
    {
        "bar": 58,
        "txt": "Des all\xe9es\xa7 des all\xe9es"
    },
    {
        "bar": 59,
        "txt": "Des Allez\xa7 j'irai"
    },
    {
        "bar": 60,
        "txt": "danser\xa7 docile"
    },
    {
        "bar": 61,
        "txt": "Sous les arbres\xa7 mobiles"
    },
    {
        "bar": 62,
        "txt": "Torsion\xa7 clipping"
    },
    {
        "bar": 63,
        "txt": "Rotations\xa7 intimes"
    },
    {
        "bar": 64,
        "txt": "\xd4 folle\xa7 nature"
    },
    {
        "bar": 65,
        "txt": "Oh pour moi\xa7 dessine"
    },
    {
        "bar": 66,
        "txt": "Un tapis de\xa7 verdure"
    },
    {
        "bar": 67,
        "txt": "Aux pixels\xa7 acides"
    },
    {
        "bar": 69,
        "txt": ""
    },
    {
        "bar": 76,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 77,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 78,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 79,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 80,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 81,
        "txt": "Des symboles"
    },
    {
        "bar": 82,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 83,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 84,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 85,
        "txt": "Des symboles\xa7 des feux"
    },
    {
        "bar": 86,
        "txt": "Des croisements\xa7 du sang"
    },
    {
        "bar": 87,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 88,
        "txt": "Ce sont des formes\xa7 abstraites"
    },
    {
        "bar": 89,
        "txt": "Des symboles"
    },
    {
        "bar": 90,
        "txt": "Des feux\xa7 des croisements"
    },
    {
        "bar": 91,
        "txt": "Des articu\xa7lations"
    },
    {
        "bar": 92,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 93,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 94,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 95,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 96,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 97,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 98,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 99,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 100,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 101,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 102,
        "txt": "Des zones\xa7 des zones"
    },
    {
        "bar": 103,
        "txt": "D\xe9zoome\xa7 d\xe9zoome"
    },
    {
        "bar": 105,
        "txt": ""
    },
    {
        "bar": 107,
        "txt": "\xa7[L'orchestre est parti]"
    },
    {
        "bar": 109,
        "txt": ""
    },
    {
        "bar": 112,
        "txt": "\xa7[Forc\xe9ment]"
    },
    {
        "bar": 114,
        "txt": ""
    },
    {
        "bar": 116,
        "txt": "\xa7[Tout est vide]"
    },
    {
        "bar": 117,
        "txt": ""
    },
    {
        "bar": 118,
        "txt": "\xa7[Enfin]"
    },
    {
        "bar": 120,
        "txt": ""
    }
];
function $2d3ddcab38f815d7$export$b3571188c770cc5a() {
    $2d3ddcab38f815d7$var$karaokeText = document.getElementById("karatext");
    // Play signal sound
    $ca39561ab740a9e5$exports.play("karappo", {
        onended: ()=>{
            $2d3ddcab38f815d7$var$clean();
        // TODO: EXIT ?
        }
    });
    $2d3ddcab38f815d7$var$createKaraokeEvents();
}
function $2d3ddcab38f815d7$var$createKaraokeEvents() {
    const beginAtBar = 0;
    $2d3ddcab38f815d7$var$karaokeText.innerHTML = "&nbsp;";
    $2d3ddcab38f815d7$var$karaokeData.forEach((d)=>{
        if (d.bar >= beginAtBar) {
            let from = 0;
            let to = 100;
            let dual = false;
            const time = d.bar * 2.4 + 2.4 - beginAtBar * 2.4;
            if (d.txt.includes($2d3ddcab38f815d7$var$MARK) && d.txt[0] !== $2d3ddcab38f815d7$var$MARK) {
                // This text includes a § marker, animate it in two parts
                dual = true;
                to = $2d3ddcab38f815d7$var$getTextWidthPercentageBeforeMarker(d.txt, $2d3ddcab38f815d7$var$karaokeText);
            }
            const cleanText = d.txt.replaceAll($2d3ddcab38f815d7$var$MARK, "");
            // Handle no animation if MARK in on first char
            if (d.txt[0] == $2d3ddcab38f815d7$var$MARK) to = 0;
            // Phase 1 (might be the only one)
            $2d3ddcab38f815d7$var$timeouts.push(setTimeout(()=>{
                $2d3ddcab38f815d7$var$karaokeText.innerHTML = `<span
                    data-text="${cleanText}"
                    style="
                        --karatext-animate-from: 0%;
                        --karatext-animate-to: ${to}%;
                    "
                >${cleanText || "&nbsp;"}</span>`;
            }, (time - 0.6) * 1000));
            // Phase 2 (only if marker present)
            if (dual) $2d3ddcab38f815d7$var$timeouts.push(setTimeout(()=>{
                $2d3ddcab38f815d7$var$karaokeText.innerHTML = `<span
                        data-text="${cleanText}"
                        style="
                            --karatext-animate-from: ${to}%;
                            --karatext-animate-to: 100%;
                        "
                    >${cleanText || "&nbsp;"}</span>`;
            }, (time + 0.6) * 1000));
        }
    });
}
// Source for getTextWidth(), getCssStyle() and getCanvasFont(): https://stackoverflow.com/a/21015393
function $2d3ddcab38f815d7$var$getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = $2d3ddcab38f815d7$var$getTextWidth.canvas || ($2d3ddcab38f815d7$var$getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}
function $2d3ddcab38f815d7$var$getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}
function $2d3ddcab38f815d7$var$getCanvasFont(el = document.body) {
    const fontWeight = $2d3ddcab38f815d7$var$getCssStyle(el, "font-weight") || "normal";
    const fontSize = $2d3ddcab38f815d7$var$getCssStyle(el, "font-size") || "16px";
    const fontFamily = $2d3ddcab38f815d7$var$getCssStyle(el, "font-family") || "Times New Roman";
    return `${fontWeight} ${fontSize} ${fontFamily}`;
}
function $2d3ddcab38f815d7$var$getTextWidthPercentageBeforeMarker(txt, element) {
    const font = $2d3ddcab38f815d7$var$getCanvasFont(element);
    const textFragment = txt.substring(0, txt.indexOf($2d3ddcab38f815d7$var$MARK));
    const cleanText = txt.replaceAll($2d3ddcab38f815d7$var$MARK, "");
    const fragmentWidth = $2d3ddcab38f815d7$var$getTextWidth(textFragment, font);
    const totalWidth = $2d3ddcab38f815d7$var$getTextWidth(cleanText, font);
    return fragmentWidth / totalWidth * 100;
}
function $2d3ddcab38f815d7$var$clearTimeouts() {
    $2d3ddcab38f815d7$var$timeouts.forEach((t)=>clearTimeout(t));
}
function $2d3ddcab38f815d7$var$clean() {
    $2d3ddcab38f815d7$var$clearTimeouts();
    $2d3ddcab38f815d7$var$karaokeText.innerHTML = "";
    $fbf4b345a0c4cd2e$export$51b36263b660c3ee(1);
}


// Development
window.DEVMODE = true;
// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
// calls for line by line time interval in milliseconds)
function $7d4c530c74e1df86$var$init() {
    $6447d0dadb519ccd$export$2cd8252107eb640b();
    $6447d0dadb519ccd$export$471f7ae5c4103ae1("Initializing...");
    $fbf4b345a0c4cd2e$export$2cd8252107eb640b();
    $6447d0dadb519ccd$export$471f7ae5c4103ae1("Loading...");
    $498b576c6cd78554$export$2cd8252107eb640b().then(()=>{
        $6447d0dadb519ccd$export$4bb981a91e4f02eb();
    });
}
function $7d4c530c74e1df86$export$b3571188c770cc5a() {
    $2d3ddcab38f815d7$export$b3571188c770cc5a();
}
$7d4c530c74e1df86$var$init();


//# sourceMappingURL=index.ccab856e.js.map
